import { render, staticRenderFns } from "./ScreenShot.vue?vue&type=template&id=46605768&scoped=true"
import script from "./ScreenShot.vue?vue&type=script&lang=js"
export * from "./ScreenShot.vue?vue&type=script&lang=js"
import style0 from "./ScreenShot.vue?vue&type=style&index=0&id=46605768&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46605768",
  null
  
)

export default component.exports